import { useCallback, useState } from 'react';

/**
 * An on/off view preference remembered in this browser (localStorage), e.g.
 * "show visit windows". Falls back to `initial` when storage is unavailable.
 */
const useStoredFlag = (key, initial) => {
  const [value, setValue] = useState(() => {
    try {
      const stored = window.localStorage.getItem(key);
      return stored === null ? initial : stored === 'true';
    } catch {
      return initial;
    }
  });
  const update = useCallback((next) => {
    setValue(next);
    try {
      window.localStorage.setItem(key, String(next));
    } catch {
      // Tarayıcı depolaması kapalıysa yalnızca bu oturumda geçerli
    }
  }, [key]);
  return [value, update];
};

export default useStoredFlag;
